module.exports = __webpack_public_path__ + "static/media/study 220721.b8925bec.png";